import React, { Component } from 'react';
import { Row, Col, Radio } from 'antd';
import { find } from 'lodash';

import { AddressButton, PureButton } from 'components/Styled';
import AddressDrawer from './AddressDrawer';

import ImageEdit from 'assets/images/business/edit.svg';

import {
  StyledFormItem,
  StyledCol,
  StyledRadioGroupHorizontal
} from 'components/Styled';

class AddressSelect extends Component {
  state = {
    drawerVisible: false
  };

  handleTypeOnChange = e => {
    this.props.updateType(e.target.value);
  };

  handleDrawerOpen = () => {
    this.setState({
      drawerVisible: true
    });
  };

  handleDrawerClose = () => {
    this.setState({
      drawerVisible: false
    });
  };

  addAddress = () => {
    this.handleDrawerClose();
    this.props.addAddress();
  };

  render() {
    const selectedAddress = this.props.selectedAddress;
    const defaultAddress = selectedAddress
      ? find(this.props.addresses, ['ref', selectedAddress])
      : this.props.addresses[0];

    // const str = this.props.showPickup ? '_pickup' : '_delivery';

    return (
      <React.Fragment>
        <div
          style={{
            paddingTop: '20px'
          }}>
          <AddressButton
            className="theme-button"
            ghost
            onClick={this.handleDrawerOpen}>
            <Row type="flex" align="middle" gutter={14}>
              <Col span={8}>
                <div style={{ fontWeight: 700, color: '#2C2C2E' }}>
                  {defaultAddress.name}
                </div>
                <div style={{ fontSize: '12px', color: '#2C2C2E' }}>
                  {defaultAddress.phoneCc ? `+${defaultAddress.phoneCc} ` : ''}
                  {defaultAddress.phone}
                </div>
              </Col>
              <Col span={14}>
                <div style={{ fontSize: '12px', color: '#2C2C2E' }}>
                  <div>{defaultAddress.city || defaultAddress.area}</div>
                  <div>
                    {defaultAddress.street1}
                    {defaultAddress.street2
                      ? '，' + defaultAddress.street2
                      : null}
                    {defaultAddress.street3
                      ? '，' + defaultAddress.street3
                      : null}
                  </div>
                  {defaultAddress.company ? (
                    <div>{defaultAddress.company}</div>
                  ) : null}
                </div>
              </Col>
            </Row>
            {!defaultAddress.type && (
              <Row type="flex" gutter={14} style={{ paddingTop: '20px' }}>
                <StyledCol
                  onClick={e => {
                    e.stopPropagation();
                  }}>
                  <StyledFormItem
                    help={this.props.help && this.props.t(this.props.help)}
                    validateStatus={this.props.validateStatus}>
                    <StyledRadioGroupHorizontal
                      onChange={this.handleTypeOnChange}
                      value={this.props.type}>
                      <Radio value={'RESIDENTIAL'}>
                        {this.props.t('pickup.form.type_residential')}
                      </Radio>
                      <Radio value={'BUSINESS'}>
                        {this.props.t('pickup.form.type_business')}
                      </Radio>
                    </StyledRadioGroupHorizontal>
                  </StyledFormItem>
                </StyledCol>
              </Row>
            )}
          </AddressButton>
          <PureButton
            onClick={this.handleDrawerOpen}
            style={{ color: '#9900A5' }}>
            <div className="buttonTheme-color">
              <img
                className="image-filter second"
                src={ImageEdit}
                style={{ marginRight: 6, height: 12, verticalAlign: 'bottom' }}
                alt="edit_icon"
              />
              {this.props.fromAddress
                ? this.props.t('pickup.form.select_other_p_address')
                : this.props.t('pickup.form.select_other_r_address')}
            </div>
          </PureButton>
        </div>
        <AddressDrawer
          t={this.props.t}
          visible={this.state.drawerVisible}
          onClose={this.handleDrawerClose}
          addAddress={this.addAddress}
          addresses={this.props.addresses}
          selectedAddress={selectedAddress}
          handleAddressClick={this.props.handleAddressClick}
          fromAddress={this.props.fromAddress}
        />
      </React.Fragment>
    );
  }
}

export default AddressSelect;
